module.exports = __webpack_public_path__ + "/images/pattern-north-america.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/pattern-north-america.png
// module id = 123
// module chunks = 0